module.exports = __webpack_public_path__ + "img/1f99b.6435006.svg";